import './resourceForm.scss'
import templateUrl from './resourceForm.html'

/**
 * Resource form base component.
 *
 * Base component used by all resource-specific forms.
 * This handles everything except the actual fields, that are transcluded by the parent component.
 *
 * Important:
 * - The component requires a resource object at `$ctrl.resource` passed down by the parent.
 * - The form controller is passed up to the parent scope as `resourceForm` for field validation.
 *
 * @example
 * <tmr-resource-form
 *   op="$ctrl.op"
 *   admin-title="ADMIN.ANTENNAS.TITLE"
 *   resource-label="$ctrl.resource.$getLabel()"
 *   submit-text="$ctrl.op == 'add' ? 'ADMIN.ANTENNAS.ADD.SUBMIT' : 'ADMIN.ANTENNAS.EDIT.SUBMIT'"
 *   on-submit="$ctrl.onSubmit()">
 *   ...form fields here...
 * </tmr-resource-form>
 *
 * @type {ngComponent}
 * @prop {('add'|'edit')} op Form type: add or edit
 * @prop {string} admin-title Page title
 * @prop {array=} breadcrumbs An optional list of breadcrumbs compatible with component {@link tmrBreadcrumbs},
 * that will be passed to {@link tmrResourceFormToolbar}
 * @prop {string} resource-label The title of the edited resource
 * @prop {boolean=} [submit-disabled=false]
 * @prop {string} submit-text The translation key of the form submit button
 * @prop {string} cancel-text The translation key of the form cancel button
 * @prop {string} submit-continue-text The translation key of the submit and continue checkbox
 * @prop {boolean} submit-and-continue
 * @prop {string} toast The confirmation message after save
 * @prop {function} on-submit The submit callback
 * @prop {function} on-submit-continue The submit and continue callback
 * @prop {function} on-cancel The Cancel callback
 */
export const tmrResourceForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceFormBaseController',
  transclude: true,
  bindings: {
    op: '<',
    adminTitle: '@',
    breadcrumbs: '<?',
    resourceLabel: '<',
    submitDisabled: '<?',
    submitText: '<',
    submitContinueText: '<',
    submitAndContinue: '<',
    toast: '<',
    onSubmit: '&',
    onSubmitContinue: '&',
    cancelText: '<',
    onCancel: '&',
  },
}

/**
 * Controller of component {@link tmrResourceForm}.
 *
 * @type {ngController}
 */
export class tmrResourceFormBaseController {
  static ngType = 'controller'

  constructor($scope, $mdMedia) {
    'ngInject'
    Object.assign(this, { $scope, $mdMedia })
  }

  onInitForm(resourceForm) {
    // Pass resourceForm controller to the parent scope that
    // needs it for validation of transcluded fields.
    this.$scope.$parent.resourceForm = resourceForm
  }

  gtMd() {
    return this.$mdMedia('gt-md')
  }
}
